import { ReactNode } from "react";
import type { TagProps } from "@/components/Tags/types";
import Tag from "@/components/Tags/Tag";

interface BadgesProps {
  tags?: TagProps[];
  children?: ReactNode;
}

const Badges = ({ tags, children }: BadgesProps) => {
  return (
    <div className="flex flex-wrap not-prose gap-2">
      {Array.isArray(tags) &&
        tags.map((tag, index) => (
          <Tag
            key={index}
            {...tag}
            title={tag.text}
            className={`px-2 py-1 text-xs font-bold [border-radius:4px] ${tag.color === "putty" && !tag.borderless ? "border-putty-700" : ""}`}
          />
        ))}
      {children}
    </div>
  );
};

export default Badges;
